import {
  // filterMode,
  // typeIcons,
  getFilterIcon
} from '../../common/filter-mode';

require('./catalog-node.component.scss');

class CatalogNodeController {
  constructor(
    $q,
    $scope,
    FilterEditorService,
    $timeout,
    // FilterCardEditorModalService,
    PermissionService,
    RouterService,
    LayoutService,
    CatalogNodeDragService,
    CurrentFilterService,
    FiltersService,
    FilterResource
  ) {
    this.$q = $q;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.CurrentFilterService = CurrentFilterService;
    this.FiltersService = FiltersService;
    this.FilterEditorService = FilterEditorService;
    // this.FilterCardEditorModalService = FilterCardEditorModalService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.drag = CatalogNodeDragService;
    this.layout = LayoutService;
    this.FilterResource = FilterResource;
    // this.filterProps = {};
  }

  get initiated() {
    return window.status === 'INIT_COMPLETE';
  }

  onChangeMarked(event) {
    event.stopPropagation();
    this.$timeout(() => {
      if (this.layout.editCatalog)  this.FiltersService.setMarked();
    }, 10);
  }

  count(propName) {
    return this.filter && this.filter.count && this.filter.count(propName) || 0;
  }

  hasProp(propName) {
    return this.filter.hasProp(propName);
  }

  setFilterProps() {
    for (const p in this.filterProps) this.filterProps[p].value =
      this.filterProps[p].count ? this.filter.count(p) : this.filter.hasProp(p);
  }


  get showReport() {
    if (this.FiltersService.openedFilters.all && !this.FiltersService.openedFilters[this.filter.id]) {
      this.showReport = this.filter.id;
      // this.FiltersService.openedFilters[this.filter.id] = true;
    }
    return this.FiltersService.openedFilters[this.filter.id];
  }


  set showReport(val) {
    if (!val) this.FiltersService.openedFilters.all = false;
    if (val && this.filter.isContainer && !this.FiltersService.loadedChildren[this.filter.id]) {
      this.loadParent(this.filter.id).then(() => {
        this.FiltersService.loadedChildren[this.filter.id] = true;
        this.FiltersService.openedFilters[this.filter.id] = val;
      });
    } else this.FiltersService.openedFilters[this.filter.id] = val;
  }

  loadParent(id) {
    return this.FiltersService.load(id);
  }

  get isActive() {
    const isActive = this.CurrentFilterService.filter && this.CurrentFilterService.filter.id === this.filter.id;
    if (isActive && !this.FiltersService.loadingFilters[this.filter.id] &&
      !this.FiltersService.loadedChildren[this.filter.id]) this.loadParent(this.filter.id);
    return isActive;
  }

  get isEditCatalog() {
    return this.layout.editCatalog;
  }

  get filterIcon() {
    return getFilterIcon(this.filter);
  }

  get filterNameClass() {
      return this.filter.do_scan ? 'highlighting': 'disabled';
  }

  get folderIcon() {
    if (this.filter.content_type === 'folder') {
      if (this.showReport)
        return 'icon-folder-open-empty';
      else
        return 'icon-folder-empty';
    }
    if (this.showReport && this.filter.children.length)
      return 'icon-folder-open-empty';
    else
      return this.filterIcon;
  }

  get isContainer() {
    return this.filter.content_type === 'folder' || this.filter.isDashboard;
  }

  selectFilter() {
    if (this.isActive) {
      if (this.filter.isContainer) this.toggleNode();
      return;
    }
    if (this.filter.content_type === 'folder') this.toggleNode();

    const resetCount = true;
    if (this.filter.facts_count && resetCount) {
      this.FilterResource.save(this.filter)
        .then(() => {
          this.FiltersService.loadedFilters[this.filter.id] = true;
          this.filter.facts_count = 0;
        })
        .catch(error => {
          console.error(!error);
        });
    }

    if (this.permission.filterConstructor && this.filter.isPolitic &&
      !this.filter.isDashboard && !this.filter.isCard && this.permission.policies) {
      this.router.selectFilter(this.filter.id, true);
      return;
    }

    this.router.selectFilter(this.filter.id);


    this.showReport = true;
  }

  toggleNode() {
    this.showReport = !this.showReport;
  }

  needToShowFilter1(filter) {
    return false;
  }

  needToShowFilter(filter) {
    if (!this.FiltersService.searchedFilters.all) {
      if (this.FiltersService.searchedFilters[filter.id]) {
        this.showReport = true;
        return true;
      } else return false;
    }
    return true;
  }

  editFilter(id) {
    return this.FilterEditorService.editModal({
      filter: this.filter,
      asNew: false,
      selectFilter: false,
    });
  }

}

export const CatalogNodeComponent = {
  template: require('./catalog-node.component.html'),
  bindings: {
    index: '<',
    model: '<',
    filter: '<',
  },
  controller: CatalogNodeController,
};



// WEBPACK FOOTER //
// ./src/filter/catalog/catalog-node.component.js